module.exports = __webpack_public_path__ + "static/media/Dariana_Gonzalez_Galicia.10690b1e.png";